module.exports = __webpack_public_path__ + "img/indexRx.30e38d21.png";